import { InfoBox } from '@react-google-maps/api';
import * as React from 'react';
import { UIWhiteBox } from '../UIContainer';
import UIFlex, { copyFlex, IFlex } from '../UIFlex';
import './UIMapInfoBox.scss';

export interface IUIMapInfoBoxProps extends React.PropsWithChildren{
    width:number;
    zIndex?: number;
    position?: google.maps.LatLng;
    onMouseOver?:()=>void;
    onMouseOut?:()=>void;
    flex?:IFlex;
}

export function UIMapInfoBox($props:IUIMapInfoBoxProps){


    let xOffset:number=-Math.round($props.width/2);
    let yOffset:number=-35;

    let flex = copyFlex({style:{width:$props.width}},$props.flex);

    if(flex.style){
        flex.style.width = $props.width;
    }

    return (
        <InfoBox
            zIndex={$props.zIndex}
            position={$props.position}            
            options={{boxClass:"mapInfoBox", closeBoxURL:"", enableEventPropagation:true, alignBottom:true, pixelOffset:new google.maps.Size(xOffset,yOffset)}}
            >
            <UIWhiteBox onMouseOver={$props.onMouseOver} onMouseOut={$props.onMouseOut} noPadding animateIntro flex={flex}>
                {$props.children}
            </UIWhiteBox>
        </InfoBox>
    );
}
